import { ApplicationConfig } from '@angular/core';
import { DatePipe } from '@angular/common';
import { provideRouter, withViewTransitions } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';

import { provideDialogDefaultOptions } from './providers/dialog-options.provider';
import { authInterceptor } from '@interceptors/auth.interceptor';
import { blobErrorInterceptor } from '@interceptors/blob-error.interceptor';
import { tenantInterceptor } from '@interceptors/tenant.interceptor';
import { documentReducer } from './store/reducers/document.reducer';
import { errorToastInterceptor } from '@interceptors/error-toast.interceptor';
import { discrepancyReducer } from './store/reducers/discrepancy.reducer';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
    providers: [
        DatePipe,
        provideRouter(routes, withViewTransitions()),
        provideHttpClient(
            withInterceptors([
                authInterceptor,
                blobErrorInterceptor,
                tenantInterceptor,
                errorToastInterceptor,
            ]),
        ),
        provideAnimationsAsync(),
        provideDialogDefaultOptions(),
        provideStore({
            document: documentReducer,
            discrepancy: discrepancyReducer,
        }),
        provideEffects(),
    ],
};
